export const getSearchParamNumber = (
  name: string,
  searchParams: URLSearchParams
) => {
  const value = searchParams.get(name);
  return value ? parseInt(value) : undefined;
};
